import React, { Fragment } from "react";
import "../resources/global.css";
import "../resources/loginRegister.css";
import Logo from "./commons/Logo";
import Form from "./commons/form";
import Joi from "joi-browser";
import userService from "../services/userService";
import { withRouter } from 'react-router-dom';

class Register extends Form {
  state = {
    data: {
      username: "",
      email: "",
      password: "",
      confirmPassword: "",
    },
    errors: {},
    step: 0,
    loading: false
  };

  customUsernameErrors = {
    "any.empty": "Don't forget a username!",
    "string.min": "Username must be at least 6 characters",
    "string.max": "Username must be less than 50 characters",
  };

  customEmailErrors = {
    "any.empty": "Don't forget an email!",
    "string.email": "That email doesn't look right",
  };

  customPasswordErrors = {
    "any.empty": "Don't forget a password!",
    "string.min": "Password must be at least 6 characters",
    "string.max": "Password must be less than 40 characters",
  };

  customConfirmPasswordErrors = {
    "any.empty": "Please confirm your password",
    "any.allowOnly": "Passwords do not match",
  };

  componentDidMount(){
    const currentUser = userService.getCurrentUser();
    if(currentUser != null){
      this.props.history.push('/');
    }
  }

  getSchema() {
    const { step } = this.state;
    if (step == 0) {
      return {
        username: Joi.string()
          .min(6)
          .max(50)
          .required()
          .label("Username")
          .error((errors) => {
            errors.forEach((err) => {
              if (this.customUsernameErrors[err.type]) {
                err.message = this.customUsernameErrors[err.type];
              }
            });
            return errors;
          }),
        email: Joi.string()
          .email()
          .max(254)
          .required()
          .label("Email")
          .error((errors) => {
            errors.forEach((err) => {
              if (this.customEmailErrors[err.type]) {
                err.message = this.customEmailErrors[err.type];
              }
            });
            return errors;
          }),
      };
    } else {
      return {
        password: Joi.string()
          .min(6)
          .max(40)
          .required()
          .label("Password")
          .error((errors) => {
            errors.forEach((err) => {
              err.message = this.customPasswordErrors[err.type];
            });
            return errors;
          }),
        confirmPassword: Joi.any()
          .valid(this.state.data.password)
          .required()
          .label("Confirm password")
          .error((errors) => {
            errors.forEach((err) => {
              err.message = this.customConfirmPasswordErrors[err.type];
            });
            return errors;
          }),
      };
    }
  }

  schema = this.getSchema();
  componentDidUpdate() {
    this.schema = this.getSchema();
  }

  startLoading = () => {
    this.setState({
      loading: true
    })
  }

  finishLoading = () => {
    this.setState({
      loading: false
    })
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    e.target.blur();
    const { step } = this.state;
    if (step == 0) {
      this.setState({ step: step + 1 });
    } else if (step == 1) {
      this.startLoading()
      try {
        const { username, email, password } = this.state.data;
        const response = await userService.registerUser(
          username,
          email,
          password
        );
        const token = response.data.token;
        this.finishLoading();
        userService.storeJwt(token);
        window.location = "/";
      } catch (error) {
        this.finishLoading();
        if (error.response && error.response.status == 400) {
          const errors = { ...this.state.errors };
          errors["confirmPassword"] = Object.values(
            error.response.data.errors
          )[0];
          this.setState({ errors });
        }
      }
    }
  };

  render() {
    const { step } = this.state;
    return (
      <div id="container">
        <div id="form-container">
          <Logo />
          <form autoComplete="off" onSubmit={this.handleSubmit}>
            {step == 0 ? (
              <Fragment>
                <h2 className="heading">Register</h2>
                <div style={{ marginBottom: 10 }} className="input-container">
                  {this.renderInput("username", "Username")}
                </div>
                <div className="input-container">
                  {this.renderInput("email", "Email")}
                </div>
                <div className="footer">{this.renderButton("Continue")}</div>
              </Fragment>
            ) : (
              <Fragment>
                <h2 className="heading">Set a password</h2>
                <div style={{ marginBottom: 10 }} className="input-container">
                  {this.renderInput("password", "Password", "password")}
                </div>
                <div className="input-container">
                  {this.renderInput(
                    "confirmPassword",
                    "Confirm Password",
                    "password"
                  )}
                </div>
                <div className="legal-notice" style={{
                  color: 'grey',
                  fontSize: 13,
                  marginTop: 15
                }}>
                  By registering, you indicate that you agree to the <a href="/tos" target="_blank">Terms of Use</a> and <a href="/privacy" target="_blank">Privacy Policy</a>
                </div>
                <div
                  className="footer"
                  style={{
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <span
                    style={{
                      color: "var(--theme-orange",
                      marginLeft: "20px",
                      cursor: "pointer",
                    }}
                    onClick={() => this.setState({ step: 0 })}
                  >
                    Back
                  </span>
                  {this.renderButton("Let's go!", this.state.loading)}
                </div>
              </Fragment>
            )}
          </form>
        </div>
      </div>
    );
  }
}

export default withRouter(Register);